import type { ReactNode } from 'react';
import { layout } from '../styles/theme';

interface PageContainerProps {
  /**
   * Which canonical page-shell width to use. `wide` (default) for overview /
   * list / table pages; `narrow` for reading / detail pages. See
   * docs/architecture/dashboard-style-guide.md.
   */
  width?: 'wide' | 'narrow';
  children: ReactNode;
}

/**
 * PageContainer — the standard content shell for every app page. Renders a
 * single centered `div` carrying one of the two canonical layout tokens
 * (`layout.pageWide` or `layout.pageNarrow`) so page widths line up across the
 * dashboard instead of every page hand-rolling its own wrapper.
 */
export function PageContainer({ width = 'wide', children }: PageContainerProps) {
  return (
    <div className={width === 'narrow' ? layout.pageNarrow : layout.pageWide}>
      {children}
    </div>
  );
}
